'use client';

import { cn } from '@polyseme/utils/cn/cn-utils';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';

type ProgressProps = React.ComponentPropsWithoutRef<
  typeof ProgressPrimitive.Root
> & {
  error?: boolean;
};

export const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, error, value, ...props }, ref) => {
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        'relative h-4 w-full overflow-hidden rounded-full bg-semantic-info-background',
        {
          'bg-semantic-error-background': error,
        },
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          'size-full flex-1 bg-semantic-info-foreground transition-all',
          {
            'bg-semantic-error-foreground': error,
          }
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;
